module.exports = "<span class=\"nav-sub\" tabindex=\"0\" (focus)=\"onFocus($event)\" (blur)=\"onBlur($event)\">\r\n  <div class=\"nav-sub-title\">\r\n    <div class=\"nav-sub-title-content\" [class.active]=\"active\">\r\n      <a> {{title}} </a>\r\n      <div class=\"nav-sub-tail\">\r\n        <div class=\"nav-sub-tail-content\" [class.active]=\"active\">\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</span>"


//////////////////
// WEBPACK FOOTER
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/unitheader/unitheader.component.html
// module id = ../../../../../src/app/core/components/unitheader/unitheader.component.html
// module chunks = main